import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialNightWorkerPage() {
    const navigate = useNavigate();
    const [time, setTime] = useState(22); // Start at 22h
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(prev => {
                const newTime = prev + 1;
                return newTime > 29 ? 22 : newTime; // Loop 22h -> 05h (29)
            });
        }, 1500); // 1.5s per hour

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        // Generate activity based on time
        const realHour = time % 24;
        let newLog = null;

        if (realHour === 23) newLog = { icon: '🌙', text: 'Le site veille. Analyse SEO nocturne...' };
        if (realHour === 1) newLog = { icon: '🇺🇸', text: 'Visiteur des USA détecté.' };
        if (realHour === 3) newLog = { icon: '📧', text: 'Demande de devis reçue (Formulaire).' };
        if (realHour === 4) newLog = { icon: '🤖', text: 'Chatbot a répondu à une question FAQ.' };

        if (newLog) {
            setLogs(prev => [newLog, ...prev].slice(0, 5));
        }
    }, [time]);

    const formatTime = (t) => {
        const h = t % 24;
        return `${h.toString().padStart(2, '0')}:00`;
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: 'linear-gradient(to bottom, #020617, #1e1b4b)', color: 'white', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>

            {/* Stars */}
            <div style={{ position: 'absolute', inset: 0, opacity: 0.5, backgroundImage: 'radial-gradient(white 1px, transparent 1px)', backgroundSize: '50px 50px' }}></div>

            {/* Moon */}
            <div style={{ position: 'absolute', top: 50, right: 100, fontSize: '5rem', opacity: 0.8, textShadow: '0 0 50px rgba(255,255,255,0.5)' }}>🌙</div>

            <div style={{ zIndex: 10, textAlign: 'center', maxWidth: 600 }}>
                <h1 style={{ fontSize: '2.5rem', fontWeight: 900, marginBottom: 10 }}>🤖 L'Assistant 24/7</h1>
                <p style={{ opacity: 0.7, fontSize: '1.2rem', marginBottom: 50 }}>Pendant que vous dormez, il travaille.</p>

                <div style={{ background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 32, padding: 40 }}>

                    <div style={{ fontSize: '4rem', fontFamily: 'monospace', fontWeight: 700, marginBottom: 30, color: '#60a5fa', textShadow: '0 0 20px rgba(96, 165, 250, 0.5)' }}>
                        {formatTime(time)}
                    </div>

                    <div style={{ minHeight: 250, display: 'flex', flexDirection: 'column', gap: 15, textAlign: 'left' }}>
                        {logs.map((log, idx) => (
                            <div key={idx} className="animate-slide-down" style={{ display: 'flex', alignItems: 'center', gap: 15, fontSize: '1.1rem', opacity: 1 - (idx * 0.2) }}>
                                <span style={{ fontSize: '1.5rem' }}>{log.icon}</span>
                                <span>{log.text}</span>
                            </div>
                        ))}
                        {logs.length === 0 && <div style={{ opacity: 0.3, textAlign: 'center', marginTop: 50 }}>Surveillance active...</div>}
                    </div>

                </div>

                <div style={{ marginTop: 50 }}>
                    <div style={{ fontSize: '1.2rem', fontWeight: 600, marginBottom: 10 }}>Économie réalisée (Secrétariat de nuit) :</div>
                    <div style={{ fontSize: '3rem', fontWeight: 900, color: '#22c55e' }}>~3 200 € / mois</div>
                </div>

                <button onClick={() => navigate('/commercial/launchpad')} style={{ marginTop: 40, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.3)', cursor: 'pointer' }}>Retour</button>
            </div>

            <style>{`.animate-slide-down { animation: slideDown 0.5s ease-out; } @keyframes slideDown { from { transform: translateY(-20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }`}</style>
        </div>
    );
}
